import React, { useState } from "react";
import Avatar, { AvatarProps } from "@mui/material/Avatar";

type UserAvatarProps = AvatarProps & {
    userId: string;
    name: string;
    avatarUrl?: string;
}

const getInitials = (name: string) => {
    return name
        .split(" ")
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase();
};

const getUniqueColor = (userId: string) => {
    let hash = 0;
    for (let i = 0; i < userId.length; i++) {
        hash = userId.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 360}, 60%, 50%)`; // Unique HSL color
    return color;
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ userId, name, avatarUrl, sx, ...rest }) => {
    const [imageError, setImageError] = useState(false);
    const initials = getInitials(name);
    const bgColor = getUniqueColor(userId);

    return (
        <Avatar
            sx={{
                bgcolor: !avatarUrl || imageError ? bgColor : "transparent",
                color: "white",
                fontSize: "1rem",
                ...(sx ?? {}),
            }}
            src={!imageError ? avatarUrl : undefined}
            onError={() => setImageError(true)}
            {...rest}
        >
            {(!avatarUrl || imageError) && initials}
        </Avatar>
    );
};